import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$alias/_app/members/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div></div>
}
